import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['readField', 'writeField', 'area', 'areaForm', 'hiddenAreaForm'];

  toggleField() {
    this.readFieldTarget.classList.toggle('hidden');
    this.writeFieldTarget.classList.toggle('hidden');
  }

  cancel() {
    this.areaFormTarget.value = this.hiddenAreaFormTarget.value;
    this.areaFormTarget.dispatchEvent(new Event('change', { bubbles: true }));
    this.toggleField();
  }

  confirm() {
    this.hiddenAreaFormTarget.value = this.areaFormTarget.value;
    this.hiddenAreaFormTarget.dispatchEvent(new Event('change', { bubbles: true }));
    const { selectedIndex } = this.hiddenAreaFormTarget;
    this.areaTarget.innerHTML = this.hiddenAreaFormTarget.options[selectedIndex].innerHTML;
    this.toggleField();
  }
}
